import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MarkdownComponent from 'components/shared/MarkdownComponent';
import { useI18n } from 'hooks/useI18n';
import { useRef, useState } from 'react';
import { StyledContent, StyledRole, StyledTrigger } from './RolesItem.styled';

type RolesItemProps = {
  name: string;
  desc: string;
};

const RolesItem = ({ name, desc }: RolesItemProps) => {
  const { t } = useI18n('roles');
  const content = useRef<HTMLDListElement>(null);
  const currentHeight = content.current?.scrollHeight;

  const [setActive, setActiveState] = useState('');

  function toggleAccordion(): void {
    setActiveState(setActive === '' ? 'is-active' : '');
  }

  const contentHeight = {
    '--subcontent-height': `${currentHeight}px`
  } as React.CSSProperties;

  const itemId = name.replace(/\s+/g, '');

  return (
    <StyledRole>
      <dt>
        <StyledTrigger
          type="button"
          id={'button_' + itemId}
          className={`${setActive}`}
          onClick={toggleAccordion}
          aria-expanded={setActive === 'is-active'}
          aria-controls={'content_' + itemId}
        >
          <h3>{t(name)}</h3>
          <FontAwesomeIcon icon={faCaretDown} />
        </StyledTrigger>
      </dt>
      <StyledContent
        ref={content}
        id={'content_' + itemId}
        className={`${setActive}`}
        style={contentHeight}
        role="region"
        aria-labelledby={'button_' + itemId}
      >
        <div>
          <MarkdownComponent content={t(desc)} />
        </div>
      </StyledContent>
    </StyledRole>
  );
};

export default RolesItem;
